import React, { useEffect, useState } from "react";
import {Button} from "@aws-amplify/ui-react";
import DisplayVerticals from "./DisplayVerticals";
import { Vertical } from "./enums";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { buildCurrentLocation } from "../GetStarted.service";

const StepTwo = ({setStep, chosenVertical, updateVerticalChoice, setProgress}:any) => {
    const navigate = useNavigate();
    const { search } = useLocation();
    const [fieldIsEmpty, setFieldIsEmpty]=useState(true);
    const [searchParams] = useSearchParams();

    useEffect(()=> {
        if (searchParams.get("vertical")) {
            handleStepNext()
        }
        setProgress('25');
        window.dataLayer.push({event: "page_view",
            page_location: buildCurrentLocation,
            page_title: "SignUp Step 2"
        });
    }, [])

    const handleStepNext=()=>{
        navigate("/self-service/password" + search);
    }



    return (
        <div className="step-container vertical-step-container">
            <div className="BlackTitle">Choose your industry</div>
            <div>
                <DisplayVerticals setFieldIsEmpty={setFieldIsEmpty} chosenVertical={chosenVertical} updateVerticalChoice={updateVerticalChoice}/>
            </div>
            <span>
                <Button
                    className="skipButton"
                    // isFullWidth={true}
                    onClick={handleStepNext}
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                >
                Skip
                </Button>
                <Button
                    className="nextButton"
                    // isFullWidth={true}
                    onClick={handleStepNext}
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                >
                Continue
                </Button>
            </span>
        </div>
    );
};

export default StepTwo;
